
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/account",
      function () {
        return require("private-next-pages/terms/account/index.tsx");
      }
    ]);
  